import React from 'react'
import {
    Provider,
} from 'react-redux'
import {
    DndProvider,
} from 'react-dnd'
import {
    HTML5Backend,
} from 'react-dnd-html5-backend'
import 'moment/locale/en-gb'
import {
    AdapterMoment,
} from '@mui/x-date-pickers/AdapterMoment'
import {
    LocalizationProvider,
} from '@mui/x-date-pickers/LocalizationProvider'
import {
    LicenseInfo,
} from '@mui/x-license'
import {
    QueryClientProvider,
} from '@tanstack/react-query'
import TagManager from 'react-gtm-module'

import queryClient from 'app/queryClient'

import Auth from 'app/Auth/AuthProvider/AuthProvider'
import SkyNetRouterProvider from 'app/SkyNetRoutes/SkyNetRouterProvider'
import {
    ErrorBoundary,
} from './ErrorBoundaries'

import ThemeProvider from './ThemeProvider'
import store from './store'

const {
    REACT_APP_MUI_LICENSE_KEY: MUI_LICENSE_KEY,
} = process.env

// Set the MUI license key for the application
LicenseInfo.setLicenseKey(MUI_LICENSE_KEY)
// Initialize Google Tag Manager
TagManager.initialize({
    gtmId: 'GTM-K5JRB76Z',
})

const App = () => {
    return (
        <ErrorBoundary>
            <DndProvider backend={HTML5Backend}>
                <Provider store={store}>
                    <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        adapterLocale="en-gb"
                    >
                        <QueryClientProvider client={queryClient}>
                            <Auth>
                                <ThemeProvider>
                                    <React.StrictMode>
                                        <SkyNetRouterProvider />
                                    </React.StrictMode>
                                </ThemeProvider>
                            </Auth>
                        </QueryClientProvider>
                    </LocalizationProvider>
                </Provider>
            </DndProvider>
        </ErrorBoundary>
    )
}

export default App
